const LK_ArrowRight =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M32.74,108.32l63.36-47.52c.73-.55,1.16-1.39,1.16-2.31s-.42-1.76-1.16-2.31L32.74,8.67v99.65M28.41,116.99V0s70.29,52.72,70.29,52.72c1.93,1.44,2.89,3.61,2.89,5.78s-.96,4.33-2.89,5.78L28.41,116.99h0Z"/>
        </svg>
    );
};

export default LK_ArrowRight;